import { InputNumberProps } from 'antd';

export * from './http-handler';
export * from './http-request';

export function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('mn-MN', {
    style: 'currency',
    currency: 'MNT',
    minimumFractionDigits: 0,
  })
    .format(amount)
    .replace('MNT', '₮');
};

export const isUrl = (str: string) => {
  const pattern = /^(https?:\/\/)[^\s]+$/i;
  return pattern.test(str);
};

export const scrollAndSubmit = ({ errors, handleSubmit }: { errors: any; handleSubmit: any }) => {
  console.log('Errors :', errors);
  handleSubmit();

  try {
    setTimeout(() => {
      const keys = Object.keys(errors || {});

      console.log('keys =>', keys);

      if (keys.length === 0) return;

      const firstErrorField = document.getElementById(keys[0]);
      console.log('firstErrorField =>', firstErrorField);
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 10);
  } catch (error) {
    console.error(error);
  }
};

export const scrollToId = (id: string) => {
  const el = document.getElementById(id);
  if (!el) return;

  el.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  });

  // Хэрвээ бага зэрэг animation өгмөөр бол
  el.classList.add('animate-pulse');
  setTimeout(() => el.classList.remove('animate-pulse'), 800);
};

export const textFormatter = (amount: number) => {
  return new Intl.NumberFormat('mn-MN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const currencyParser = (value: any) =>
  value?.replace(/\₮\s?|(,*)/g, '') as unknown as number as any;

export const currencyFormatter: InputNumberProps<number | any>['formatter'] = (value) => {
  const [start, end] = `${value}`.split('.') || [];
  const v = `${start}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `₮ ${end ? `${v}.${end}` : `${v}`}`;
};

export const parser = (value: any) => value?.replace(/(,*)/g, '') as unknown as number as any;

export const formatter: InputNumberProps<number>['formatter'] = (value) => {
  const [start, end] = `${value}`.split('.') || [];
  const v = `${start}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return end ? `${v}.${end}` : v;
};

export const downloadPDF = async (fileUrl: string) => {
  try {
    const response = await fetch(fileUrl, {
      method: 'GET',
    });

    if (!response.ok) throw new Error('Failed to fetch PDF');

    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'file.pdf';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error(error);
    alert('PDF татахад алдаа гарлаа');
  }
};

// MediaApi.upload (fetch хувилбар)
// 1) blob:/data:/http(s):// эсвэл File/Blob — бүгдийг File болгох
async function toFile(input: File | Blob | string, fallbackName = 'upload.bin'): Promise<File> {
  if (input instanceof File) return input;
  if (input instanceof Blob) {
    const ext = input.type?.split('/')[1] || 'bin';
    return new File([input], `upload.${ext}`, { type: input.type || 'application/octet-stream' });
  }
  if (typeof input === 'string') {
    // blob:, data:, http(s): бүгдийг fetch → blob → File
    const res = await fetch(input);
    if (!res.ok) throw new Error(`Fetch failed for ${input} (${res.status})`);
    const blob = await res.blob();
    const ext = blob.type?.split('/')[1] || 'bin';
    return new File([blob], fallbackName.includes('.') ? fallbackName : `upload.${ext}`, {
      type: blob.type || 'application/octet-stream',
    });
  }
  throw new Error('Unsupported input type');
}

// 2) Файл upload (fetch)
export async function upload(
  file: File | Blob,
  opts?: {
    fieldName?: string; // default: "file"
    token?: string; // Authorization хэрэгтэй бол
    baseUrl?: string; // өөр домэйн бол
  },
  accessToken?: string
): Promise<string> {
  const fd = new FormData();
  const name = (file as File).name ?? 'upload.bin';
  fd.append(opts?.fieldName ?? 'file', file, name);

  console.log('accessToken:', accessToken);

  const res = await fetch(`${process.env.REACT_APP_API_URL}/api/media/upload`, {
    method: 'POST',
    body: fd,
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  if (!res.ok) throw new Error(`Upload failed: ${res.status} ${await res.text().catch(() => '')}`);
  const data = await res.json(); // { url: string } гэж үзсэн
  return data.url;
}

// 3) Дуудах нь: эхлээд 4 зураг File болгоод, дараа нь upload
export async function uploadFirstFour(images: Array<File | Blob | string>, accessToken: string) {
  const files = await Promise.all(
    images.slice(0, 4).map((x, i) => toFile(x, `image_${i + 1}.bin`))
  );
  const urls = await Promise.all(files.map((f) => upload(f, {}, accessToken)));
  return urls; // ← Энд ЗӨВХӨН серверийн URL-ууд байна
}

// Жишээ:
// const imageUrls = await uploadFirstFour(images);

// Дуудах нь:
// const imageUrls = await Promise.all(images.slice(0, 4).map((f) => upload(f)));
